"use strict";

import { Platform } from 'react-native';
export let StateMachineEvent = /*#__PURE__*/function (StateMachineEvent) {
  StateMachineEvent["NATIVE_BEGIN"] = "nativeBegin";
  StateMachineEvent["NATIVE_START"] = "nativeStart";
  StateMachineEvent["FINALIZE"] = "finalize";
  StateMachineEvent["LONG_PRESS_TOUCHES_DOWN"] = "longPressTouchesDown";
  StateMachineEvent["CANCEL"] = "cancel";
  return StateMachineEvent;
}({});
function getAndroidStatesConfig(handlePressIn, handlePressOut) {
  return [{
    eventName: StateMachineEvent.NATIVE_BEGIN
  }, {
    eventName: StateMachineEvent.LONG_PRESS_TOUCHES_DOWN,
    callback: handlePressIn
  }, {
    eventName: StateMachineEvent.FINALIZE,
    callback: handlePressOut
  }];
}
function getAndroidAccessibilityStatesConfig(handlePressIn, handlePressOut) {
  return [{
    eventName: StateMachineEvent.NATIVE_BEGIN,
    callback: handlePressIn
  }, {
    eventName: StateMachineEvent.LONG_PRESS_TOUCHES_DOWN,
    optional: true
  }, {
    eventName: StateMachineEvent.FINALIZE,
    callback: handlePressOut
  }];
}
function getIosStatesConfig(handlePressIn, handlePressOut) {
  return [{
    eventName: StateMachineEvent.LONG_PRESS_TOUCHES_DOWN
  }, {
    eventName: StateMachineEvent.NATIVE_BEGIN,
    callback: handlePressIn
  }, {
    eventName: StateMachineEvent.NATIVE_START
  }, {
    eventName: StateMachineEvent.FINALIZE,
    callback: handlePressOut
  }];
}
function getWebStatesConfig(handlePressIn, handlePressOut) {
  return [{
    eventName: StateMachineEvent.NATIVE_BEGIN
  }, {
    eventName: StateMachineEvent.NATIVE_START
  }, {
    eventName: StateMachineEvent.LONG_PRESS_TOUCHES_DOWN,
    callback: handlePressIn
  }, {
    eventName: StateMachineEvent.FINALIZE,
    callback: handlePressOut
  }];
}
function getMacosStatesConfig(handlePressIn, handlePressOut) {
  return [{
    eventName: StateMachineEvent.LONG_PRESS_TOUCHES_DOWN
  }, {
    eventName: StateMachineEvent.NATIVE_BEGIN,
    callback: handlePressIn
  }, {
    eventName: StateMachineEvent.NATIVE_START
  }, {
    eventName: StateMachineEvent.FINALIZE,
    callback: handlePressOut
  }];
}
function getUniversalStatesConfig(handlePressIn, handlePressOut) {
  return [{
    eventName: StateMachineEvent.FINALIZE,
    callback: event => {
      handlePressIn(event);
      handlePressOut(event);
    }
  }];
}
export function getStatesConfig(handlePressIn, handlePressOut, screenReaderActive) {
  if (Platform.OS === 'android') {
    return screenReaderActive ? getAndroidAccessibilityStatesConfig(handlePressIn, handlePressOut) : getAndroidStatesConfig(handlePressIn, handlePressOut);
  } else if (Platform.OS === 'ios') {
    return getIosStatesConfig(handlePressIn, handlePressOut);
  } else if (Platform.OS === 'web') {
    return getWebStatesConfig(handlePressIn, handlePressOut);
  } else if (Platform.OS === 'macos') {
    return getMacosStatesConfig(handlePressIn, handlePressOut);
  } else {
    // Unknown platform - using minimal universal setup.
    return getUniversalStatesConfig(handlePressIn, handlePressOut);
  }
}
//# sourceMappingURL=stateDefinitions.js.map